/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * Priority levels for error display and handling.
 * Higher values indicate higher priority - errors with higher priority
 * take precedence when multiple errors occur simultaneously.
 */
export enum ErrorPriority {
  /**
   * Emergency Alert System (EAS) OSD - highest priority. Always outranks
   * every other OSD/dialog request, per the EAS OSD specification.
   */
  EAS_ALERT = 1000,

  /**
   * Network connectivity error.
   */
  NO_NETWORK_ERROR = 999,

  /**
   * Location-based restriction error.
   */
  LOCATION_RESTRICTION = 996,

  /**
   * General restriction errors (adult, blacklisted, etc.).
   */
  GENERAL_RESTRICTIONS = 995,

  /**
   * Session creation or player errors.
   */
  SESSION_AND_PLAYER_ERROR = 994,

  /**
   * "Still there?" idle timeout prompt - lowest priority.
   */
  STILL_THERE = 900
}
